module.exports = __webpack_public_path__ + "static/media/cov_1st_aid.9ab8f2ef.png";